module.exports = __webpack_public_path__ + "img/trash-alt.0fe46e5a.svg";